import { Bed, Bath, Tv, Wifi, Car } from "lucide-react";
import RoomDetail from "./RoomDetail";
import doubleRoomClassic from "@/assets/double-room-classic.png";
import doubleRoomWardrobe from "@/assets/double-room-wardrobe.jpg";
import doubleRoomBath from "@/assets/double-room-bath.jpg";
import doubleRoomChair from "@/assets/double-room-chair.jpg";
import doubleRoomTv from "@/assets/double-room-tv.jpg";
import doubleRoomDetail from "@/assets/double-room-detail.jpg";
import doubleRoomOverview from "@/assets/double-room-overview.png";
import { useLanguage } from "@/i18n/LanguageContext";
import { useRoomContent } from "@/hooks/useRoomContent";

const DoubleRoom = () => {
  const { t } = useLanguage();
  const { current } = useRoomContent("double");
  const rd = t.roomData;
  const images = [
    { src: doubleRoomClassic, alt: current?.title || t.subpageHeroes.doubleRoom.title },
    { src: doubleRoomChair, alt: "Seating" },
    { src: doubleRoomTv, alt: "TV" },
    { src: doubleRoomBath, alt: "Bathroom" },
    { src: doubleRoomWardrobe, alt: "Wardrobe" },
    { src: doubleRoomDetail, alt: "Detail" },
    { src: doubleRoomOverview, alt: "Overview" },
  ];
  const amenityLabels = current?.amenities?.length ? current.amenities : rd.double.amenities;
  const amenities = amenityLabels.map((label, i) => ({
    icon: [Bed, Bath, Tv, Wifi, Car][i],
    label,
  }));
  return (
    <RoomDetail
      title={current?.title || t.subpageHeroes.doubleRoom.title}
      subtitle={current?.description || t.subpageHeroes.doubleRoom.subtitle}
      images={images}
      amenities={amenities}
      features={rd.features}
      highlight={{ image: doubleRoomDetail, title: current?.highlight || rd.double.highlight, subtitle: current?.highlightSub || rd.double.highlightSub }}
    />
  );
};

export default DoubleRoom;
